import React, { useEffect, useState, useRef } from 'react';
import * as am5 from '@amcharts/amcharts5';
import * as am5percent from '@amcharts/amcharts5/percent';
import am5themes_Animated from '@amcharts/amcharts5/themes/Animated';
import annotation_plus from '../../../../../images/expand-icon.svg';
import { WellByStatus } from '../../../model/WellByStatus';
import { AppUser } from '../../../../user/model/AppUser';
import download from '../../../../../../src/images/download-icon.svg';
import championx from '../../../../../../src/images/championxLogo.png';
import { downloadDashboardCSV } from '../../../DashboardServices';
import WellByStatusModel from './WellByStatusModel';
import { useAppDispatch, useAppSelector } from '../../../../../hooks/storeHooks';
import { fetchWellByStatusDetails } from '../../../DashboardSlice';
import NoData from '../../no-data/NoData';
import { ToastContainer, toast } from 'react-toastify';
import Loader from '../../../../common/page-loader/ComponentLoader';
import * as am5plugins_exporting from '@amcharts/amcharts5/plugins/exporting';
import moment from 'moment-timezone';
import html2canvas from 'html2canvas';


interface WellByStatusGraphProps {
  groupName: string;
}

const WellByStatusGraph: React.FC<WellByStatusGraphProps> = ({ groupName }) => {
  const dispatch = useAppDispatch();
  const wellByStatus = useAppSelector((state) => state.dashboard.PerformanceSnapshot?.wellByStatus);
  const loading = useAppSelector((state) => state.dashboard?.performanceLoading);
  const heading = 'System Status';
  const subHeading = 'Total wells';
  const count = useAppSelector((state) => state.dashboard.PerformanceSnapshot?.wellByStatusCount);
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const storedUserData = localStorage.getItem('loggedInUser');
  const storedUser: AppUser = storedUserData ? JSON.parse(storedUserData) : null;
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const hElement = document.getElementById('main-root');

  const wellByStatusDetails = useAppSelector((state) => state.dashboard.wellByStatusDetails);
  const currentUser = useAppSelector((state) => state?.user?.currentUser);
  const dropdownRef = useRef<HTMLDivElement>(null);
  const wellbystatuschartdiv = useRef<HTMLDivElement | null>(null);
  const root = useRef<am5.Root | null>(null);

  useEffect(() => {
    if (!groupName) return;
    console.log("groupnamegroupname after", groupName);
    dispatch(fetchWellByStatusDetails({ userId: storedUser?.id, name: 'wellbystatus', groupName: groupName }));
  }, [groupName])

  const printWidgetAsPDF = () => {

    const input = document.getElementById('wellByStatus-container'); // Replace with your widget 


    if (root.current) {
      const exporting = am5plugins_exporting.Exporting.new(root.current, {
        menu: am5plugins_exporting.ExportingMenu.new(root.current, {}),
      });
      Promise.all([
        exporting.getPdfmake(),
        exporting.export('png'),

      ]).then((res) => {
        const pdfMake = res[0];
        const str = moment().format("MMM-DD-YYYY hh:mm:ss A");
        const doc = {
          pageSize: 'A4',
          pageOrientation: 'portrait',
          pageMargins: [30, 30, 30, 30],
          footer: {
            columns: [
              {
                text: `Generated By: ${currentUser?.firstName || ''} ${currentUser?.lastName || ''}`,
                alignment: 'left',
                "width": "50%",
                "bold": true,
                "margin": [10, 10],
                "fontSize": 9,
                "color": "black",
                "decoration": 'underline',

              },
              {
                text: "Generated on : " + str, alignment: 'right',
                "width": "50%",
                "bold": true,
                "margin": [10, 10],
                "fontSize": 9,
                "color": "black",
                "decoration": 'underline',

              }
            ]
          },
          content: [] as any[],
          styles: {
            tblheader: {
              fontSize: 12,
              color: 'white',
              fillColor: '#01485e',
              alignment: 'center',
            },
            tblheader1: {
              fontSize: 12,
              color: 'white',
              fillColor: '#01485e',
              alignment: 'left',
            },
            tbody1: {
              alignment: 'center',
            }
          }
        };

        const rect = {
          type: 'rect',
          x: -32,
          y: -20, //could be negative to account for padding
          w: 450,
          h: 25,
          linearGradient: ['#01485e', '#01485e']
        };
        const rectHead = {
          type: 'rect',
          x: -32,
          y: -20, //could be negative to account for padding
          w: 150,
          h: 25,
          linearGradient: ['#484848', '#484848']
        };
        doc.content.push({

          "columns": [{

            stack: [
              { canvas: [rect] },
              {
                columns: [
                  {
                    width: rect.w / 2,
                    noWrap: false, //clip at with by wrapping to next line and...
                    maxHeight: rect.h, //don't show the wrapped text
                    "image": championx,
                    "fit": [55, 55],
                    "margin": [5.5, 7.5, 3],
                    "background": 'white',
                  },
                  {
                    "text": "Landing Page",
                    width: rect.w / 2,
                    "alignment": "left",
                    "bold": true,
                    "margin": [35, 5],
                    "fontSize": 13,
                    "color": "white",
                  }],
                relativePosition: {
                  x: rect.x,
                  y: - rect.h
                }
              }
            ]
          },
          {
            stack: [
              { canvas: [rectHead] },
              {
                columns: [
                  {
                    width: rectHead.w,
                    noWrap: false, //clip at with by wrapping to next line and...
                    maxHeight: rect.h, //don't show the wrapped text
                    text: 'LOOKOUT',
                    color: 'white',
                    "bold": true,
                    "alignment": "right",
                    "font-size": 10,

                  }],
                relativePosition: {
                  x: -80,
                  y: - 20
                }
              }
            ]
          }
          ]
        });
        doc.content.push({
          "text": " ",
          "width": "100%",
        });

        doc.content.push(
          {
            text: 'System Status',
            width: "*",
            alignment: "center",
            fontSize: 18,
            margin: [0, 0, 0, 5],
          },
          {
            canvas: [
              {
                type: 'line',
                x1: 210, y1: 0,
                x2: 330, y2: 0,
                lineWidth: 1
              }
            ],
            margin: [0, 0, 0, 20]
          }
        );

        html2canvas(input as HTMLElement, { backgroundColor: "#001023" })
          .then((canvas) => {
            canvas.style.marginTop = '10%';
            const imgData = canvas.toDataURL('image/png');

            doc.content.push({
              "alignment": "center",
              image: imgData,
              width: 450,
              height: 180,
              margin: [0, 0, 0, 20],
            });
            const tblBody = [[
              { text: 'Well by status', bold: true, style: 'tblheader1' },
              { text: 'Running', bold: true, style: 'tblheader' },
              { text: 'Disabled', bold: true, style: 'tblheader' },
              { text: 'Shutdown', bold: true, style: 'tblheader' }]
            ];

            if (wellByStatusDetails) {
              const dynamicHeaders = ['operator', 'running', 'disabled', 'shutdown'];
              wellByStatusDetails.forEach((item: any) => {
                const row: any = dynamicHeaders.map(key => {
                  if (key == 'operator') {
                    return { text: item[key].toString(), bold: false }; // Convert each value to string
                  }
                  return { text: item[key].toString(), bold: false, style: 'tbody1' }; // Convert each value to string
                });

                tblBody.push(row);
              });

              doc.content.push({
                table: {
                  headerRows: 1,
                  widths: Array(dynamicHeaders.length).fill('*'), body: tblBody,
                },
              });
            }

            const fileName = "Lookout-Landing_Page_SystemStatus_" + str + ".pdf"

            pdfMake.createPdf(doc).download(fileName);
          })
          .catch((err) => {
            console.error("Failed to generate PDF", err);
          });

      });
    }

  };

  const handleDownloadCSV = () => {
    toast.success('System Status CSV download is in progress.!');
    const currentTime = moment().format("MMM-DD-YYYY hh:mm:ss A");
    const userId = storedUser?.id;
    const widgetName = 'WellByStatus';
    const data = { userId, widgetName, groupName };
    downloadDashboardCSV(data).then((response) => {
      const url = window.URL.createObjectURL(new Blob([response]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', 'Lookout-Landing_Page_SystemStatus_' + currentTime + '.csv');
      document.body.appendChild(link);
      link.click();
    }).catch((error) => {
      if (error?.message !== '') {
        toast.error('System Status CSV download is failed. Please try after sometime!');
      }
    });
    setIsDropdownOpen(false);
  };

  const openModal = (event: any) => {
    event.preventDefault();
    event.stopPropagation();
    setModalIsOpen(true);
    hElement && hElement?.classList.add('modal-open');
  };

  const handleClose = () => {
    setModalIsOpen(false);
    hElement && hElement?.classList.remove('modal-open');
  };

  const initializeChart = (chartId: string, data: WellByStatus[]): am5.Root | undefined => {
    if (wellbystatuschartdiv.current) {
      root.current = am5.Root.new(wellbystatuschartdiv.current);
      // const root = am5.Root.new(chartId);
      root.current.setThemes([am5themes_Animated.new(root.current)]);

      const chart = root.current.container.children.push(
        am5percent.PieChart.new(root.current, {
          layout: root.current.horizontalLayout,
          innerRadius: am5.percent(60),
        }),
      );

      const series = chart.series.push(
        am5percent.PieSeries.new(root.current, {
          name: 'Series',
          valueField: 'value',
          categoryField: 'status',
          legendLabelText: '[#F7F9F9]{category}[/]',
          legendValueText: '[#F7F9F9]{value}[/]',
        }),
      );
      series.slices.template.setAll({
        stroke: am5.color('#FFFFFF'),
        strokeWidth: 1,
      });
      series.data.setAll(data);

      const dataItemsArray = Array.from(series.dataItems.values());
      dataItemsArray.forEach((dataItem) => {
        const status = dataItem.get('category') as string;
        let sliceColor = '';
        if (status === 'Running') {
          sliceColor = '#003747';
        } else if (status === 'Not Running') {
          sliceColor = '#60BFDA';
        } else if (status === 'Shutdown') {
          sliceColor = '#A6DBEA';
        } else if (status === 'Offline') {
          sliceColor = '#DCF1F7';
        } else if (status === 'Comm Issues') {
          sliceColor = '#00789E';
        } else {
          sliceColor = '#4A5463';
        }
        dataItem.set('fill', am5.color(sliceColor));
      });

      series.labels.template.set('forceHidden', true);
      series.ticks.template.set('forceHidden', true);

      const legend = chart.children.push(
        am5.Legend.new(root.current, {
          centerY: am5.percent(50),
          y: am5.percent(50),
          layout: root.current.verticalLayout,
        }),
      );

      legend.valueLabels.template.setAll({ textAlign: "right" })
      legend.labels.template.setAll({
        maxWidth: 140,
        width: 80,
        oversizedBehavior: "wrap"
      });

      legend.markerRectangles.template.setAll({
        cornerRadiusTL: 10,
        cornerRadiusTR: 10,
        cornerRadiusBL: 10,
        cornerRadiusBR: 10,
        width: 10,
        height: 10,
      });

      legend.markerRectangles.template.setAll({
        y: 4,
      });

      legend.data.setAll(series.dataItems);
      return root.current;
    }
    return undefined;
  };

  useEffect(() => {
    let rootInstance: am5.Root | undefined;
    if (wellByStatus && count) {
      rootInstance = initializeChart(`wellbystatuschartdiv`, wellByStatus);
    }
    return () => {
      if (rootInstance) {
        rootInstance.dispose();
      }
    };
  }, [wellByStatus, heading, count]);


  const handleClickOutside = (event: MouseEvent) => {
    if (dropdownRef.current && !dropdownRef.current.contains(event.target as Node)) {
      setIsDropdownOpen(false);
    }
  };

  useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  return (
    <>
      <ToastContainer position='top-right' autoClose={3000} />
      <div className='table-header-section pie-section'>
        <div className='title'>{heading}</div>
        <div className='header-icon'>
          <button className='expand-btn cancelSelectorName' onClick={openModal} style={{ cursor: 'pointer', zIndex: 0 }}>
            <img src={annotation_plus} alt='Expand' className='img-border' />
          </button>
          <div className='dropdown-container' ref={dropdownRef}>
            <button className='dropdown-btn cancelSelectorName' onClick={() => setIsDropdownOpen(!isDropdownOpen)}>
              <span className='dot'></span>
              <span className='dot'></span>
              <span className='dot'></span>
            </button>
            {isDropdownOpen && (
              <div className='dropdown-options'>
                <button>Actions</button>
                <button className={`btn btn-default cancelSelectorName ${(wellByStatus === null || wellByStatus === undefined || wellByStatus?.length === 0) ? 'btn-disabled' : ''}`}
                  onClick={printWidgetAsPDF}>
                  <img src={download} alt='icon' className='btn-icon' />
                  Download PDF
                </button>
                <button className={`btn btn-default cancelSelectorName ${(wellByStatus === null || wellByStatus === undefined || wellByStatus?.length === 0) ? 'btn-disabled' : ''}`} onClick={handleDownloadCSV}>
                  <img src={download} alt='icon' className='btn-icon' />
                  Download CSV
                </button>
              </div>
            )}
          </div>
        </div>
      </div>
      <hr />
      <div id="wellByStatus-container" className='pie-container-dashboard nodata'>
        {loading ? (
          <div className='flex items-center justify-center w-100'>
            <Loader />
          </div>
        ) : count ? (
          <>
            <div className='total-count'>
              <p>{subHeading}</p>
              <h2>{count}</h2>
            </div>
            <div id={`wellbystatuschartdiv`} ref={wellbystatuschartdiv} className='chart-wrapper'></div>
          </>
        ) : !modalIsOpen ? (
          <NoData heading='No data found' />
        ) : (
          ''
        )}
        <WellByStatusModel
          isOpen={modalIsOpen}
          onRequestClose={handleClose}
          heading={heading}
          subHeading={subHeading}
          count={count}
          wellByStatus={wellByStatus}
        />
      </div>
    </>
  );
};

export default WellByStatusGraph;
